import {
  DOCUSIGN_RETURN_MESSAGES,
  ENROLLMENT_COMMON_MESSAGES
} from '../../../constants/enrollmentContent'
import { getEnrollmentApiErrorMessage } from '../../../utils/enrollmentApiErrorMessage'

export const getRequestErrorMessage = (error: unknown, fallback: string) => {
  return getEnrollmentApiErrorMessage(error, fallback)
}

export const getRequestStatus = (error: unknown) => {
  if (typeof error !== 'object' || error === null || !('response' in error)) {
    return null
  }

  const response = error.response
  if (typeof response !== 'object' || response === null || !('status' in response)) {
    return null
  }

  return typeof response.status === 'number' ? response.status : null
}

export const isStartDateMondayError = (message: string) => {
  return /classStartDate must be a Monday/i.test(message)
}

export const getDocuSignReturnMessage = (eventName: string) => {
  switch (eventName) {
    case 'decline':
      return DOCUSIGN_RETURN_MESSAGES.declined
    case 'ttl_expired':
      return DOCUSIGN_RETURN_MESSAGES.expired
    default:
      return DOCUSIGN_RETURN_MESSAGES.incomplete
  }
}

export { ENROLLMENT_COMMON_MESSAGES }
